module.exports = __webpack_public_path__ + "img/09_3_1_3.deb3f453.png";